export default "__VITE_ASSET__fcUqCgrX__"